/**
 * Mode-aware state map factory.
 *
 * On first GameUpdate (when the wire payload's `gameType` is known),
 * `GameFlowController` calls `buildStatesForMode(gameType, sm, game)`
 * to get the state map for the current room and installs it via
 * `stateMachine.registerStates(map)`. Adding a new game mode means
 * adding a new factory file here and a new branch in this switch.
 */

import type { State } from '../State.js';
import type { StateMachine } from '../StateMachine.js';
import type { SDLGame } from '../SDLGame.js';
import { buildCeeloStates } from './CeeloStates.js';
import { buildCrapsStates } from './CrapsStates.js';

export type GameType = 'ceelo' | 'craps';

export function buildStatesForMode(
  mode: GameType,
  sm: StateMachine,
  game: SDLGame,
): Map<string, State> {
  switch (mode) {
    case 'ceelo':
      return buildCeeloStates(sm, game);
    case 'craps':
      return buildCrapsStates(sm, game);
    default: {
      const exhaustive: never = mode;
      throw new Error(`buildStatesForMode: unknown mode ${exhaustive}`);
    }
  }
}
